import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  UserProfile: [],
  BusinessProfile: null,
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  businessStatus: "idle",
  error: null,
  IsLogin: true,
};
export const fetchUserProfile = createAsyncThunk("/Users/profilePopulate", async () => {
  const response = await axiosInstanceAuth.get(`/Users/profilePopulate`);
  return response.data;
});

export const fetchBusinessProfile = createAsyncThunk(
  "/Business/getBusinessForUpdatePrpfile",
  async () => {
    const response = await axiosInstanceAuth.get(`/Business/getBusinessForUpdatePrpfile`);
    return response.data;
  }
);

const ProfileSlice = createSlice({
  name: "UserProfile",
  initialState,
  reducers: {
    ProfileAdded: {
      reducer(state, action) {
        state.UserProfile?.push(action.payload);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchUserProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserProfile = action.payload.Data;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchBusinessProfile.pending, (state) => {
        state.businessStatus = "loading";
      })
      .addCase(fetchBusinessProfile.fulfilled, (state, action) => {
        state.businessStatus = "succeeded";
        state.BusinessProfile = action.payload.Data;
      })
      .addCase(fetchBusinessProfile.rejected, (state, action) => {
        state.businessStatus = "failed";
        state.error = action.error.message;
      });
  },
});

export const getUserProfile = (state) => state.UserProfile;
export const getBusinessProfile = (state) => state.UserProfile.BusinessProfile;

export const { ProfileAdded } = ProfileSlice.actions;

export default ProfileSlice.reducer;

